import { render } from "./Associate.vue?vue&type=template&id=2dd34b18&scoped=true"
import script from "./Associate.vue?vue&type=script&lang=js"
export * from "./Associate.vue?vue&type=script&lang=js"

import "./Associate.vue?vue&type=style&index=0&id=2dd34b18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2dd34b18"

export default script